"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FragmentAbilityHandler = exports.FragmentActorAbilityFactory = exports.FragmentAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const Random_1 = require("../../utils/Random");
const Duration_1 = require("../../core/Duration");
const core_1 = require("../../core/vfx/core");
const LocationSelector_1 = require("../../core/vfx/LocationSelector");
const core_2 = require("../../core/effects/core");
const AbilityDamage_1 = require("../../core/AbilityDamage");
class FragmentAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.Fragment;
        this.__typeName = "Fragment";
    }
}
exports.FragmentAbilityArgs = FragmentAbilityArgs;
let FragmentActorAbilityFactory = class FragmentActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("Fragment", "AllEnemies", 3);
    }
};
FragmentActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("Fragment")
], FragmentActorAbilityFactory);
exports.FragmentActorAbilityFactory = FragmentActorAbilityFactory;
let FragmentAbilityHandler = class FragmentAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        container.applyMultiAttack({
            sequence,
            attackerId: ability.invokerId,
            attackType: "ranged",
            abilityKey: ability.args.__typeName,
            targets: container.selectLivingTargets(ability.invokerId, Target_1.Target.AllEnemies)
                .map((targetId) => ({
                jitter: 0,
                targetId,
                damages: [
                    AbilityDamage_1.AbilityDamage.Power("Physical", 70)
                ],
                effects: [
                    {
                        targetId,
                        duration: Duration_1.Duration.Turns(5),
                        effect: new core_2.VulnerabilityEffectArgs((0, Random_1.random)(5, 15))
                    }
                ],
            })),
            onHit: (sequence, target) => {
                sequence.push(new core_1.InstantVfxStepArgs(new LocationSelector_1.ActorVfxLocationSelector(target.targetId, "feet", "behind"), "FireMagicCircle"));
            },
        });
    }
};
FragmentAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.Fragment)
], FragmentAbilityHandler);
exports.FragmentAbilityHandler = FragmentAbilityHandler;
